export default "__VITE_ASSET__D$W8mMKQ__"